import { Component, OnInit, Input } from '@angular/core';

interface client {
  image: string;
  text: string
};

@Component({
  selector: 'app-clients-logo',
  templateUrl: './clients-logo.component.html',
  styleUrls: ['./clients-logo.component.css']
})
export class ClientsLogoComponent implements OnInit {

  @Input() brand_class: string | undefined;
  /**
   * Clients Logo
   */
   clients_logo: client[] = [
    {
      image: "assets/templos/amal.png",
        text: 'Host Temple:'
    },
       {
           image: "assets/templos/logo-rio.png",
           text: 'Support:'
       },
       {
           image: "assets/templos/abou.png",
           text:'Affiliated Temples:'
       },

    {
        image: "assets/templos/hikmat.png",
        text:'.'
    },
    {
        image: "assets/templos/salah.png",
        text:'.'

    },
    {
        image: "assets/templos/bolivia.jpg",
        text:'.'
    },
    {
        image: "assets/templos/alrei.png",
        text:'.'
    },

       {
           image: "assets/templos/alalala.png",
           text:'.'
       },
       {
           image: "assets/templos/paraguai.jpeg",
           text:'.'
       },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
